module.exports = __webpack_public_path__ + "img/10no-one.3d5427da.jpg";